import { preventDefault } from "@fullcalendar/core/internal";
import { Button, Space } from "antd";
import { truncate } from "lodash";
import { MouseEventHandler, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { AuthenticationState } from "../interfaces/users";
import { api } from "../config";

export const FreightPage = () => {
  const [file, setFile] = useState<File | undefined>();
  const { token } = useSelector((state: AuthenticationState) => state);
  const [loading, setLoading] = useState(false)
  const inputRef = useRef(null);

  const handleOpenFileUploader = () => {
    //@ts-ignore
    inputRef?.current?.click();
  };

  const handleDragOver = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    console.log(e.target.files);
  };

  const handleDragFile = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    console.log(e.dataTransfer.files[0])
    setFile(e.dataTransfer.files[0]);
  };

  // useEffect(() => {
  //   const fn = (e: any) => {
  //     alert('asd')
  //     e.stopPropagation();
  //     e.preventDefault();
  //     e
  //   };

  //   document.addEventListener("mouseup", fn);

  //   return () => {
  //     document.removeEventListener("mouseup", fn);
  //   };
  // }, []);

  const handleClearFile = () => {
    setFile(undefined)
  }

  const handleSubmitFile = async () => {
    if (!file) return toast.error('É necessário adicionar um arquivo!')
    try {
      setLoading(true)
      const formData = new FormData()

      formData.append('file', file)
      
      const response = await api(token).post('/freight/upload-report', formData, {"Content-Type": 'multipart/form-data'})

      toast.success('Arquivo enviado com sucesso!')
      setFile(undefined)
    } catch (error: any) {
      toast.error(error.response.data.error);
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div>Fretes: </div>
      <div className="w-full h-screen flex justify-center">
        <div className="rounded-3xl shadow-md p-4 h-fit cursor-pointer">
          <p>Adicionar tabela de frete:</p>

          <div
            onClick={handleOpenFileUploader}
            onMouseUp={handleDragFile}
            draggable
            onDragEnd={handleDragFile}
            onDrop={handleDragFile}
            onDragOver={handleDragOver}
            className="h-96 w-96 border-dashed rounded-xl border-blue-400 flex justify-center items-center"
          >
            {file ? (
                <p>{truncate(file?.name, {length: 50}) ?? ''}</p>
            ) : (
                <p>Selecione ou Arraste um arquivo!</p>
            )}
            
          </div>
          <input type="file" hidden ref={inputRef} />
          <div className="flex w-full justify-between mt-4">
            <Button onClick={handleClearFile}>Limpar</Button>
          <Button loading={loading} onClick={handleSubmitFile} variant="solid" color="primary">Enviar</Button>
          </div>
        </div>
        
      </div>
    </>
  );
};
